import { render, staticRenderFns } from "./basic-main.vue?vue&type=template&id=2098930f"
import script from "./basic-main.vue?vue&type=script&lang=js"
export * from "./basic-main.vue?vue&type=script&lang=js"
import style0 from "./basic-main.vue?vue&type=style&index=0&id=2098930f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2098930f')) {
      api.createRecord('2098930f', component.options)
    } else {
      api.reload('2098930f', component.options)
    }
    module.hot.accept("./basic-main.vue?vue&type=template&id=2098930f", function () {
      api.rerender('2098930f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic-main/basic-main.vue"
export default component.exports